﻿export default class ChangePasswordViewModel {
    public currentPassword: string = '';
    public newPassword: string = '';
    public repeatPassword: string = '';
}